/* eslint-disable import/no-unresolved */
<template>
  <v-main>
    <LoginModal :show="showLogin" :alert="loginAlert" :action="loginAction" @credentials="loginUser" />
    <v-container fluid class="pa-0" v-if="!showLogin">
      <v-card height="100vh" class="d-flex flex-column elevation-0 hide-overflow">
        <section class="search-row b-b">
          <PositionSearch />
          <v-tabs v-model="activeTab" v-if="loggedIn">
            <v-tab v-for="tab in tabs" :key="tab.id" :to="tab.id" v-show="checkAccess(tab.roles)">
              {{ tab.title }}
            </v-tab>
          </v-tabs>
        </section>
        <section v-if="errored" style="
            padding: 0 2em;
            height: 82vh;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
          ">
          <p>
            We're sorry, we're not able to retrieve this information at the
            moment, please try back later
          </p>
        </section>
        <v-row no-gutters class="hide-overflow flex-nowrap" style="flex: 100%"
          v-else-if="activeTab == '/admin/campaigns'">
          <v-col class="b-r">
            <v-row no-gutters class="align-center justify-space-between">
              <v-col cols="3">
                <v-select no-gutter v-model="campaignFilter" :items="campaignFilters" prepend-icon="mdi-filter"
                  :menu-props="{ top: false, offsetY: true }"></v-select>
              </v-col>
              <v-col cols="4" class="mr-2 text-right">
                <CampaignEditor :showDialog="editCampaign" :editCampaign="selectedCampaign"
                  @campaignCreated="campaignCreated" />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <CampaignList :search="campaignFilter" @selectCampaign="selectCampaign" @deleteCampaign="deleteCampaign"
                @showDialog="editCampaign = !editCampaign" />
            </v-row>
          </v-col>
          <v-col style="position: relative; overflow-y: auto;" class="ma-2" v-if="selectedCampaign !== null">
            <v-card class="w-100" color="primary">
              <div class="campaign-header pa-4">
                <!-- <img
                  :src="selectedCampaign.imageUrl"
                  style="max-width: 200px"
                  class="mb-4"
                /> -->
                <h2 class="mb-4" style="color: white; text-transform: uppercase">
                  {{ selectedCampaign.title }}
                </h2>
                <p style="color: white">{{ selectedCampaign.description }}</p>
                <v-btn v-if="selectedCampaign.externalUrl" text color="white">
                  Read more
                  <v-icon right dense>mdi-open-in-new</v-icon>
                </v-btn>
              </div>
              <v-row
                class="w-100 mr-0 ml-0"
                style="background-color: white;"
              >
                <v-text-field
                  required
                  placeholder="Job, company, category or area name"
                  prepend-inner-icon="mdi-magnify"
                  v-model="searchCampaignJob"
                ></v-text-field>
              </v-row>
              <v-data-table
                :headers="campaignHeaders"
                :items="filteredCampaignJobs"
                loading-text="Fetching campaign data..."
                :loading="campaignJobsLoading"
                :items-per-page="10" style="width: 100%">
                <template v-slot:[`item.clustering.categories`]="{ item }">
                  <span>
                    {{ item.clustering && item.clustering.categories ? item.clustering.categories.map(category => category.name).join(', ') : '' }}
                  </span>
              </template>

              <template v-slot:[`item.clustering.seniority.id`]="{ item }">
                  <span>
                    {{ item.clustering && item.clustering.seniority ? capitalizeFirstLetter(item.clustering.seniority.id) : '' }}
                  </span>
              </template>
              
              </v-data-table>
            </v-card>
            <!-- <iframe
              :src="'https://placeholder.com/'"
              style="
                width: 100%;
                height: 100%;
                border: 4px solid rgba(0, 0, 0, 0.2);
                box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.2);
                border-radius: 10px;
              "
            >
            </iframe> -->
            <div style="
                box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
                font-size: 0.8rem;
                position: absolute;
                top: 0;
                right: 0;
                display: block;
                padding: 0.5rem 1rem;
                background: white;
                border-radius: 6px;
                text-transform: uppercase;
              ">
              Campaign preview
            </div>
          </v-col>
          <v-col class="hide-overflow d-flex align-center justify-center" v-else>
            Select a campaign
          </v-col>
        </v-row>
        <v-row no-gutters class="hide-overflow flex-nowrap" style="flex: 100%" v-else-if="activeTab == '/admin/users'">
          <v-col class="b-r auto-overflow">
            <v-row class="pt-4 pl-4 pr-4 pb-3 b-b mb-0" dense>
              <v-col class="col-md-3">
                <v-text-field label="Search users" v-model="userTextFilter" outlined clearable hide-details
                  prepend-inner-icon="mdi-magnify" dense></v-text-field>
              </v-col>
              <v-col class="mr-2 text-right">
                <v-btn color="primary" v-on:click="addUser()">
                  <v-icon left dense>mdi-plus</v-icon>
                  Add user
                </v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <UserList @selectUser="selectUser" @deleteUser="deleteUser" :textFilter="userTextFilter" />
            </v-row>
          </v-col>
          <v-col cols="12" md="4" style="position: relative" v-if="editUser">
            <UserEdit :user="selectedUser" @saved="userSaved" />
          </v-col>
          <v-col cols="12" md="4" style="position: relative" class="hide-overflow d-flex align-center justify-center"
            v-else>
            Select a user
          </v-col>
        </v-row>
        <v-row no-gutters class="hide-overflow flex-nowrap" style="flex: 100%"
          v-else-if="activeTab == '/admin/content'">
          <v-col class="b-r">
            <!-- <v-row no-gutters class="align-center justify-space-between">
              <v-col class="col-md-3">
                <v-select
                  no-gutter
                  v-model="pageFilter"
                  :items="pageFilters"
                  prepend-icon="mdi-filter"
                  :menu-props="{ top: false, offsetY: true }"
                ></v-select>
              </v-col>
              <v-col class="col-md-3 mr-2 text-right">
                <v-btn color="primary" v-on:click="addUser()">
                  <v-icon left dense>mdi-plus</v-icon>
                  Add page
                </v-btn>
              </v-col>
            </v-row> -->
            <v-row no-gutters>
              <ContentList @selectPage="selectPage" :search="pageFilter" />
            </v-row>
          </v-col>
          <v-col cols="12" md="6" style="position: relative" class="auto-overflow" v-if="editPage">
            <ContentEditor :page="selectedPage" @saved="pageSaved" />
          </v-col>
          <v-col cols="12" md="6" style="position: relative" class="hide-overflow d-flex align-center justify-center"
            v-else>
            Select a page
          </v-col>
        </v-row>
        <v-row v-else-if="activeTab == '/admin/info'" no-gutters class="hide-overflow flex-nowrap">
          <v-col v-if="getPage">
            <v-col cols="12" md="4" v-if="getPage.content.side.length > 0">
              <v-card class="pa-0 ma-0">
                <div class="ml-4 mr-4 pt-4 pb-1">
                  <ContentRenderer :content="getPage.content.side" class="mb-4" />
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" md="8">
              <ContentRenderer :content="getPage.content.main" />
            </v-col>
          </v-col>
          <v-col class="hide-overflow d-flex align-center justify-center" v-else>
            Page not found.
          </v-col>
        </v-row>
        <v-row v-else-if="activeTab == '/admin/categories'" no-gutters class="hide-overflow flex-nowrap">
          <v-col cols="12" md="12">
            <CategoryList />
          </v-col>
        </v-row>
        <v-row v-else no-gutters class="hide-overflow flex-nowrap h-100">
          <v-col class="hide-overflow">
            <PositionListAdmin />
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from 'axios';
import PositionListAdmin from '@/components/PositionListAdmin.vue';
import PositionSearch from '@/components/PositionSearch.vue';
import LoginModal from '@/components/LoginModal.vue';
import CampaignList from '@/components/CampaignList.vue';
import CampaignEditor from '@/components/CampaignEditor.vue';
import UserList from '@/components/UserList.vue';
import UserEdit from '@/components/UserEdit.vue';
import ContentList from '@/components/ContentList.vue';
import ContentEditor from '@/components/ContentEditor.vue';
import ContentRenderer from '@/components/ContentRenderer.vue';
import CategoryList from '@/components/CategoryList.vue';

export default {
  name: 'Admin',
  components: {
    PositionListAdmin,
    PositionSearch,
    LoginModal,
    CampaignList,
    CampaignEditor,
    UserList,
    UserEdit,
    ContentList,
    ContentEditor,
    ContentRenderer,
    CategoryList,
  },
  data() {
    return {
      showLogin: false,
      loggedIn: false,
      loginAlert: null,
      tab: null,
      errored: false,
      loading: true,
      positionCount: 0,
      activeTab: null,
      searchCampaignJob: '',
      campaignJobsLoading: false,
      tabs: [
        {
          id: '/admin',
          title: 'Jobs',
          roles: ['superadmin', 'jobster', 'user'],
        },
        {
          id: '/admin/campaigns',
          title: 'Campaigns',
          roles: ['superadmin', 'jobster'],
        },
        {
          id: '/admin/categories',
          title: 'Categories',
          roles: ['superadmin'],
        },
        {
          id: '/admin/users',
          title: 'Users',
          roles: ['superadmin', 'jobster'],
        },
        {
          id: '/admin/content',
          title: 'Content',
          roles: ['superadmin'],
        },
        {
          id: '/admin/info',
          title: 'Info',
          roles: ['superadmin', 'jobster', 'user'],
        },
      ],
      campaignHeaders: [
        { text: 'Open position', value: 'title' },
        { text: 'Company', value: 'employer.name' },
        { text: 'Area', value: 'location.area' },
        { text: 'Seniority', value: 'clustering.seniority.id' },
        { text: 'Category', value: 'clustering.categories' },

      ],
      campaignFilter: '',
      campaignFilters: [
        { text: 'All', value: '' },
        { text: 'Published', value: 'published' },
        { text: 'Draft', value: 'draft' },
      ],
      editCampaign: false,
      selectedCampaign: null,
      // userRoleFilter: "",
      // userRoleFilters: [
      //   { text: "All", value: "" },
      //   { text: "Admin", value: "admin" },
      //   { text: "Jobster", value: "jobster" },
      //   { text: "Content producer", value: "content-producer" },
      // ],
      userTextFilter: '',
      editUser: false,
      selectedUser: {},
      currentRoles: [null],

      pageFilter: '',
      pageFilters: [{ text: 'All', value: '' }],
      editPage: false,
      selectedPage: {},
    };
  },
  mounted() {
    if (!this.$store.state.JWT) {
      console.log('No JWT, showing login');
      this.showLogin = true;
    } else {
      console.log('JWT exists, trying to restore login');
      // JWT exists, try to get user roles and set logged in
      this.loading = true;
      this.$store
        .dispatch('dispatchGetUserRoles', { userId: this.$store.state.userId, own: true })
        .then((userRoles) => {
          console.log('User roles retrieved:', userRoles);
          this.currentRoles = userRoles.inherits;
          this.loggedIn = true;
        }).catch((error) => {
          console.log('Failed to get user roles:', error);
          // If getting roles fails, clear JWT and show login
          this.$store.dispatch('logout');
          this.showLogin = true;
        }).finally(() => {
          this.loading = false;
        });
    }
    this.$store.dispatch('dispatchGetPages');
  },
  watch: {
    $route(to, from) {
      // Refresh job list when navigating to jobs
      if (to.name == 'admin' && from.name !== 'admin') {
        this.refresh();
      }
    },
  },
  methods: {
    loginUser(username, password) {
      this.showLogin = false;
      this.loading = true;
      if (!this.$store.state.JWT) {
        this.$store
          .dispatch('dispatchLogin', { username, password })
          .catch((error) => {
            if (error.response.status === 401) {
              // alert("Sign-in failed (invalid login credentials)");
              this.loginAlert = 'Sign-in failed (invalid login credentials)';
            }
            this.errored = true;
            this.showLogin = true;
          })
          .then((auth) => {
            if (this.$route.query.action == 'onboarding') {
              this.$router.push({ name: 'users-admin', query: { userId } });
            }

            this.$store
              .dispatch('dispatchGetJobsAdmin')
              .then(() => {
              })
              .finally(() => {
                this.errored = false;
                this.loading = false;
              });

            // Get user details
            this.$store
              .dispatch('dispatchGetUserRoles', { userId: auth.id, own: true })
              .then((userRoles) => {
                this.currentRoles = userRoles.inherits;
                this.loggedIn = true;
              }).catch(() => {
                // TODO/FIXME: Other roles should be returned from BE
                this.currentRoles = ['jobster'];
                this.loggedIn = true;
              });
          });

        this.$store.dispatch('dispatchTags');
      } else {
        this.loading = false;
      }
    },
    refresh() {
      this.loading = true;
      this.$store.dispatch('dispatchGetJobsAdmin').finally(() => {
        this.errored = false;
        this.loading = false;
      });
    },
    selectCampaign(campaign) {
      // this.editCampaign = true;
      this.selectedCampaign = campaign;
      this.campaignJobsLoading = true;
      this.$store.dispatch('dispatchGetCampaignJobs', { campaignId: campaign.id }).finally(() => {
        this.campaignJobsLoading = false;
      });
    },
    deleteCampaign(campaignId) {
      // TODO: Switch to Vuetify confirmation dialog
      if (!confirm('Are you sure you want to delete this campaign?')) {
        return;
      }
      this.$store
        .dispatch('dispatchDeleteCampaign', { campaignId })
        .then(() => {
          this.$store.dispatch('dispatchGetCampaigns').then(() => {
            this.selectedCampaign = null;
            this.editCampaign = false;
          });
        })
        .catch((error) => {
          console.error('Error deleting campaign:', error);
        });
    },
    campaignCreated(campaign) {
      this.editCampaign = false;
      this.$store.dispatch('dispatchGetCampaigns').then(() => {
        this.selectCampaign(campaign);
      });
    },
    addUser() {
      this.editUser = true;
      this.selectedUser = {};
    },
    selectUser(user) {
      if (this.selectedUser == user) {
        this.editUser = false;
        this.selectedUser = {};
      } else {
        this.editUser = true;
        this.selectedUser = user;
      }
    },
    deleteUser(userId) {
      // TODO: Switch to Vuetify confirmation dialog
      if (!confirm('Are you sure you want to delete this user?')) {
        return;
      }
      this.$store.dispatch('dispatchDeleteUser', { userId }).then(() => {
        this.$store.dispatch('dispatchGetUsers');
      }).catch((error) => {
        console.error('Error deleting user:', error);
      });
    },
    userSaved(user) {
      this.editUser = false;
      this.selectedUser = {};
      this.$store.dispatch('dispatchGetUsers');
    },
    selectPage(page) {
      if (this.selectePage == page) {
        this.editPage = false;
        this.selectedPage = {};
      } else {
        this.editPage = true;
        this.selectedPage = page;
      }
    },
    pageSaved(page) {
      this.editPage = false;
      this.selectedPage = {};
    },
    checkAccess(roles) {
      let hasAccess = false;
      this.currentRoles.forEach((role) => {
        if (roles.includes(role)) {
          hasAccess = true;
        }
      });
      return hasAccess;
    },
    capitalizeFirstLetter(str) {
      if (!str) return ''; // Handle empty or undefined values
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },
  },
  computed: {
    // Get data from vuex store
    getSearchResults() {
      return this.$store.state.searchResults ? this.$store.state.searchResults.filter(el => el.match) : [];
    },
    getSelectedPosition() {
      return this.$store.state.selectedPosition;
    },
    getSearchTerms() {
      return this.$store.state.searchTerms;
    },
    getCampaignJobs() {
      return this.$store.state.campaignJobs;
    },
    filteredCampaignJobs() {
      const jobs = this.getCampaignJobs || [];
      if (!this.searchCampaignJob) {
        return jobs;
      }
      // eslint-disable-next-line max-len
      const q = this.searchCampaignJob.toLowerCase();
      
      return jobs.filter(job => {
        const jobCategories = (job.clustering && job.clustering.categories ? job.clustering.categories.flatMap(({ name }) => name) : []) || [];
        return (job.title && job.title.toLowerCase().includes(q))
        || (job.employer && job.employer.name && job.employer.name.toLowerCase().includes(q))
        || (job.location && job.location.area && job.location.area.toLowerCase().includes(q))
        || (jobCategories.some(categoryName => categoryName.toLowerCase().includes(q)));
      });
    },
    loginAction() {
      return this.$route.name;
    },
    getPage() {
      const page = this.$store.state.pages.find(page => page.id === 'info');

      return page;
    },
  },
};
</script>
<style scoped>
.main-search {
  margin-top: 0.5em;
  margin-bottom: -0.8em;
}

@media screen and (min-width: 992px) {
  .search-row {
    padding: 0em 1.6em;
  }
}
</style>
<style>
.v-data-table tbody tr:hover {
  cursor: pointer;
}
</style>
